import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_API;

// Login user - Step 1 of TFA
export const loginUser = createAsyncThunk(
  "auth/login-user",
  async (credentials, { rejectWithValue }) => {
    try {
      const res = await axios.post(`${API}/auth/login`, credentials, {
        headers: { "Content-Type": "application/json" },
      });

      // Backend should indicate if OTP verification is required
      // Example: { requiresOtp: true, userId: "...", email: "..." }
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { error: "Network or server error" }
      );
    }
  }
);

// Verify OTP - Step 2 of TFA
export const VerifyUser = createAsyncThunk(
  "auth/verify-user",
  async ({ userId, verificationCode }, { rejectWithValue }) => {
    try {
      const res = await axios.post(
        `${API}/auth/verify-user`,
        { userId, verificationCode },
        { headers: { "Content-Type": "application/json" } }
      );
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { error: "Invalid OTP or server error" }
      );
    }
  }
);

// Resend OTP
export const resendOtp = createAsyncThunk(
  "auth/resend-otp",
  async ({ userId }, { rejectWithValue }) => {
    try {
      const res = await axios.post(
        `${API}/auth/resend-otp`,
        { userId },
        { headers: { "Content-Type": "application/json" } }
      );
      return res.data; // { message: "OTP sent successfully" }
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { error: "Failed to resend OTP" }
      );
    }
  }
);

// Logout
export const logoutUser = createAsyncThunk(
  "auth/logout-user",
  async ({ email, accessToken }, { rejectWithValue }) => {
    try {
      const res = await axios.post(
        `${API}/logout`,
        { email },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: accessToken,
          },
        }
      );
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: error.message });
    }
  }
);

// Check token
export const checkToken = createAsyncThunk(
  "auth/token-check",
  async (token, { rejectWithValue }) => {
    try {
      const res = await axios.post(
        `${API}/check-token`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: error.message });
    }
  }
);

// Update password
export const updatePassword = createAsyncThunk(
  "auth/update-password",
  async ({ user, accessToken }, { rejectWithValue }) => {
    try {
      const res = await axios.put(
        `${API}/update-password`,
        { user },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: accessToken,
          },
        }
      );
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: error.message });
    }
  }
);

// Forget password
export const forgetPassword = createAsyncThunk(
  "auth/forget-password",
  async (email, { rejectWithValue }) => {
    try {
      const res = await axios.post(
        `${API}/auth/forget-password`,
        { email },
        { headers: { "Content-Type": "application/json" } }
      );
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: error.message });
    }
  }
);

// Reset password
export const resetPassword = createAsyncThunk(
  "auth/reset-password",
  async ({ password, resetToken }, { rejectWithValue }) => {
    try {
      const res = await axios.post(
        `${API}/auth/reset-password`,
        { password, resetToken },
        { headers: { "Content-Type": "application/json" } }
      );
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: error.message });
    }
  }
);
